/**
 * Internal collector state. Module-private — accessed only by `init` and `get`.
 * Tests can reset it via `_resetStateForTests`.
 */
type CollectorState = {
  disabled: boolean
  initializedAt: number
}

let state: CollectorState | undefined

export function setState(next: CollectorState): void {
  state = next
}

export function getState(): CollectorState | undefined {
  return state
}

export function isInitialized(): boolean {
  return state !== undefined
}

/**
 * Test-only reset hook. Not exported from `index.ts`.
 * Production code must never call this.
 */
export function _resetStateForTests(): void {
  state = undefined
}
